import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/PrivilegesResource.ts
var n = class n extends t {
	static {
		this.baseUrl = "/rest/organizations";
	}
	getGlobalGroupPrivileges() {
		return this.api.get("/rest/globalprivileges");
	}
	getUserPrivileges(t) {
		return this.api.get(`${n.baseUrl}/${t || e.orgPlaceholder}/members/privileges`);
	}
};
export { n as PrivilegesResource };

//# sourceMappingURL=PrivilegesResource.js.map